/* RESPONSIBLE TEAM: team-automation-foundations */
import OutboundBaseListController from 'embercom/lib/outbound/base-list-controller';

export default class AppsAppOperatorResolutionBotIndexController extends OutboundBaseListController {}
